<template lang="pug">
    el-dialog(:title='dialogTitle' width='85%' :visible.sync='dialogVisible' :append-to-body='true')
        el-card(shadow='never')
            div
                el-row(:span='24')
                    el-col(:span='12')
                        strong 培训组：
                        span {{ courseInfo.groupName || '-' }}
                    el-col(:span='12')
                        strong 培训班：
                        span {{ courseInfo.trainName || '-' }}
                el-row(:span='24' style='margin-top:10px;')
                    el-col(:span='12')
                        strong 课程：
                        span {{ courseInfo.code || '-' }}
                    el-col(:span='12')
                        strong 课程时间：
                        span {{ courseInfo.trainTime || '' }} {{ courseInfo.strTime || '' }}{{ courseInfo.endTime ? '-' + courseInfo.endTime : '' }}
                el-row(:span='24' style='margin-top:10px;')
                    el-col(:span='12')
                        strong 场地：
                        span {{ courseInfo.placeCode || '-' }}
                    el-col(:span='12')
                        strong 课程状态：
                        span(v-if='courseInfo.courseStatus === 0') 未开始
                        span(v-else-if='courseInfo.courseStatus === 1') 进行中
                        span(v-else-if='courseInfo.courseStatus === 2') 已结束
                        span(v-else) -
                el-row(:span='24' style='margin-top:10px;')
                    el-col(:span='24')
                        strong 教练：
                        el-select(v-model='courseInfo.coachId' ref='coachSelect' :disabled='coachChanging' placeholder='请选择教练' filterable clearable size='mini' style='width:300px;' @change='coachChange')
                            el-option(v-for='item in coachList' :key='item.id' :value='item.id' :label='`${item.name}·${item.coachLevel}·${item.phone}`')
                                span {{ item.name }}
                                span &nbsp;·&nbsp;{{ item.coachLevel }}
                                span &nbsp;·&nbsp;{{ item.phone }}
        el-divider
        el-card(shadow='never')
            div(slot='header' style='display:flex;justify-content:space-between;align-items:center;')
                font.font_label 参训人员 ({{ userList.length }}人)
                el-button(type='primary' size='mini' icon='el-icon-download' :loading='exporting' @click='exportExcel') 导出
            el-table(:data='userList' border @selection-change='handleSelectionChange' v-loading='loading')
                el-table-column(prop='memberName' label='姓名' align='center')
                el-table-column(prop='mobile' label='会员账号' align='center' width='130')
                el-table-column(prop='trainName' label='培训班' align='center')
                el-table-column(prop='courseInfo' label='参加课程' align='center' width='180')
                el-table-column(prop='payStatus' label='状态' align='center' width='90')
                    template(slot-scope='scope')
                        font(v-if='scope.row.payStatus === 0') 未支付
                        font(v-if='scope.row.payStatus === 1') 支付中
                        font(v-if='scope.row.payStatus === 2') 支付成功
                        font(v-if='scope.row.payStatus === 3') 支付失败
                        font(v-if='scope.row.payStatus === 4') 超时
                        font(v-if='scope.row.payStatus === 5') 申请退款
                        font(v-if='scope.row.payStatus === 6') 退款中
                        font(v-if='scope.row.payStatus === 7') 退款成功
                        font(v-if='scope.row.payStatus === 8') 退款失败
                        font(v-if='scope.row.payStatus === 9') 支付已关闭
                        font(v-if='scope.row.payStatus === 10') 退款已取消
                el-table-column(prop='enrollStatus' label='报名状态' align='center' width='90')
                    template(slot-scope='scope')
                        font(v-if='scope.row.enrollStatus === 0') 未报名
                        font(v-else-if='scope.row.enrollStatus === 1') 已报名
                        font(v-else) -
                el-table-column(prop='attendStatus' label='销课状态' align='center' width='90')
                    template(slot-scope='scope')
                        font(v-if='scope.row.attendStatus === 0') 待销课
                        font(v-else-if='scope.row.attendStatus === 1') 已销课
                        font(v-else-if='scope.row.attendStatus === 2') 已请假·已销课
                        font(v-else) -
                el-table-column(prop='courseAmount' label='支付金额' align='center')
        span.dialog-footer(slot='footer')
            el-button(@click='dialogVisible = false') 关 闭
</template>

<script>
export default {
  name: 'CourseUserDialog',
  data () {
    return {
      loading: false,
      exporting: false,
      userList: [],
      selectedList: [],
      courseInfo: {},
      dialogVisible: false,
      currentCourseId: '',
      coachList: [],
      coachSaving: false,
      suppressCoachChange: false,
      previousCoachId: null,
      exportColumns: [
        { label: '姓名', prop: 'memberName' },
        { label: '会员账号', prop: 'mobile' },
        { label: '培训班', prop: 'trainName' },
        { label: '参加课程', prop: 'courseInfo' },
        { label: '支付状态', prop: 'payStatus' },
        { label: '报名状态', prop: 'enrollStatus' },
        { label: '销课状态', prop: 'attendStatus' },
        { label: '支付金额', prop: 'payAmount' }
      ],
      payStatusMap: {
        0: '未支付', 1: '支付中', 2: '支付成功', 3: '支付失败', 4: '超时',
        5: '申请退款', 6: '退款中', 7: '退款成功', 8: '退款失败', 9: '支付已关闭', 10: '退款已取消'
      },
      enrollStatusMap: { 0: '未报名', 1: '已报名' },
      attendStatusMap: { 0: '待销课', 1: '已销课', 2: '已请假·已销课' }
    }
  },
  computed: {
    dialogTitle () {
      return this.courseInfo.code ? '人员管理 - ' + this.courseInfo.code : '人员管理'
    }
  },
  watch: {
    dialogVisible (val) {
      if (!val && this.currentCourseId) {
        this.$emit('refresh')
      }
    }
  },
  methods: {
    init (row) {
      this.currentCourseId = row.id
      this.courseInfo = row || {}
      this.previousCoachId = (row && row.coachId) || null
      this.userList = []
      this.selectedList = []
      this.dialogVisible = true
      this.loading = true
      this.loadCoachList()
      this.loadUserList()
    },
    // 加载教练列表
    loadCoachList () {
      this.$http({
        url: this.$http.adornUrl('/pxCoach/list'),
        method: 'post',
        data: { page: 1, limit: 9999 }
      }).then((data) => {
        if (data && data.code === 0) {
          this.coachList = (data.page && data.page.records) || data.list || []
        } else {
          this.coachList = []
        }
      }).catch(() => {
        this.coachList = []
      })
    },
    // 教练变更
    coachChange (val) {
      if (this.suppressCoachChange) return
      if (val === undefined || val === null) return
      const oldCoachId = this.previousCoachId
      if (val === oldCoachId) return
      const oldCoach = this.coachList.find(c => c.id === oldCoachId)
      const oldCoachName = oldCoach ? oldCoach.name : (this.courseInfo.coachName || '')
      const newCoach = this.coachList.find(c => c.id === val)
      const newCoachName = newCoach ? newCoach.name : ''

      this.$http({
          url: this.$http.adornUrl('/pxTrainCourse/adjustCoach'),
          method: 'post',
          data: {
            id: this.currentCourseId,
            coachId: val
          }
        }).then((data) => {
          if (data && data.code === 0) {
            this.$message.success('修改成功')
            this.courseInfo.coachId = val
            this.previousCoachId = val
          } else {
            this.$message.error(data.msg || '修改失败')
            this.courseInfo.coachId = oldCoachId
            if (oldCoach) this.courseInfo.coachName = oldCoach.name
          }
        }).catch(() => {
          this.$message.error('请求错误')
          this.courseInfo.coachId = oldCoachId
          if (oldCoach) this.courseInfo.coachName = oldCoach.name
        })

      // this.$confirm(`确认将本堂课教练由 "${oldCoachName}" 改为 "${newCoachName}" ?`, '修改本堂课教练', {
      //   confirmButtonText: '确认修改',
      //   cancelButtonText: '返回',
      //   type: 'warning'
      // }).then(() => {
      //   this.$http({
      //     url: this.$http.adornUrl('/pxTrainCourse/adjustCoach'),
      //     method: 'post',
      //     data: {
      //       id: this.currentCourseId,
      //       coachId: val
      //     }
      //   }).then((data) => {
      //     if (data && data.code === 0) {
      //       this.$message.success('修改成功')
      //       this.courseInfo.coachId = val
      //       this.previousCoachId = val
      //     } else {
      //       this.$message.error(data.msg || '修改失败')
      //       this.courseInfo.coachId = oldCoachId
      //       if (oldCoach) this.courseInfo.coachName = oldCoach.name
      //     }
      //   }).catch(() => {
      //     this.$message.error('请求错误')
      //     this.courseInfo.coachId = oldCoachId
      //     if (oldCoach) this.courseInfo.coachName = oldCoach.name
      //   })
      // }).catch(() => {
      //   this.courseInfo.coachId = oldCoachId
      //   if (oldCoach) this.courseInfo.coachName = oldCoach.name
      // })
    },
    // 加载参训人员
    loadUserList () {
      this.$http({
        url: this.$http.adornUrl('/pxTrain/queryCoursePersons/' + this.currentCourseId),
        method: 'post'
      }).then((data) => {
        if (data && data.code === 0) {
          this.userList = data.list || data.records || []
        } else {
          this.userList = []
        }
        this.loading = false
      }).catch(() => {
        this.userList = []
        this.loading = false
      })
    },
    handleSelectionChange (val) {
      this.selectedList = val
    },
    // 导出参训人员
    exportExcel () {
      if (!this.userList || !this.userList.length) {
        this.$message.info('没有要导出的数据!')
        return
      }
      this.exporting = true
      const exportData = this.userList.map(item => ({
        memberName: item.memberName || '',
        mobile: item.mobile || '',
        trainName: item.trainName || '',
        courseInfo: item.courseInfo || '',
        payStatus: this.payStatusMap[item.payStatus] || '-',
        enrollStatus: this.enrollStatusMap[item.enrollStatus] || '-',
        attendStatus: this.attendStatusMap[item.attendStatus] || '-',
        payAmount: item.payAmount ? '￥' + item.payAmount : '-'
      }))
      this.$export.excel({
        columns: this.exportColumns,
        data: exportData,
        title: (this.courseInfo.trainName) + '第' + (this.courseInfo.code) + '节参训人员'
      }).then(() => {
        this.$message.success('导出表格成功')
      }).finally(() => {
        this.exporting = false
      })
    }
  }
}
</script>

<style scoped>
.font_label {
  font-weight: bold;
  font-size: 14px;
}
</style>
